import { EventAuth } from './event-auth.js';
import { StateValue } from '../storage/state-value.js';
import { object } from '../typing/object.js';
import { record } from '../typing/record.js';
import { string } from '../typing/string.js';
import { date } from '../typing/date.js';
import { TypeOf } from '../typing/type-of.js';

export const StoredEvent = object('StoredEvent', {
  id: string(),
  event: string(),
  data: record(string(), StateValue),
  storedAt: date(),
  createdAt: date(),
  auth: EventAuth,
  streamArgs: record(string(), string()),
  annotations: record(string(), string()),
  authId: string(),
  pattern: string(),
  realm: string(),
  tenant: string(),
});

export type StoredEvent = TypeOf<typeof StoredEvent>;
